import { render, staticRenderFns } from "./BusinessTaskRelease.vue?vue&type=template&id=6532b221&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./BusinessTaskRelease.vue?vue&type=script&lang=js&"
export * from "./BusinessTaskRelease.vue?vue&type=script&lang=js&"
import style0 from "./BusinessTaskRelease.vue?vue&type=style&index=0&id=6532b221&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6532b221",
  null
  
)

export default component.exports